// extracted by mini-css-extract-plugin
export default {"root":"StuTable_root__pLi9E","student":"StuTable_student__unD8F","stuName":"StuTable_stuName__pxZLX","stuNo":"StuTable_stuNo__sK-MA"};